import { render } from "./OfficeQuestionariosTab.vue?vue&type=template&id=eb73ab54&scoped=true&ts=true"
import script from "./OfficeQuestionariosTab.vue?vue&type=script&lang=ts"
export * from "./OfficeQuestionariosTab.vue?vue&type=script&lang=ts"

import "./OfficeQuestionariosTab.vue?vue&type=style&index=0&id=eb73ab54&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-eb73ab54"]])

export default __exports__